import Text14 from '@sdk/components/ui/typography/Text14';
import gettext from '@sdk/lang/gettext';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';

import { BannerWithIconContainer } from '@web/timesheets/EmployeePendingConsentTimesheetViewModal/components/ModalBanner/modalBanner.styles';
import { ConsentDeniedTooltip } from '@web/timesheets/EmployeePendingConsentTimesheetViewModal/components/ModalBanner/ConsentDeniedTooltip';

type Props = {
  employeeName: string;
  consentDenyReason: string;
};
const ManagerViewEmployeeDeniedNewEntriesBanner = ({ employeeName, consentDenyReason }: Props) => (
  <BannerWithIconContainer
    themeColor={ThemeColorType.iconGray}
    justifyContent="space-between"
    alignItems="center">
    <div>
      <Text14 themeColor={ThemeColorType.white} semiBold>
        {gettext('%(employeeName)s denied the timesheet edits.', { employeeName })}
      </Text14>
    </div>

    <ConsentDeniedTooltip consentDenyReason={consentDenyReason} />
  </BannerWithIconContainer>
);

export default ManagerViewEmployeeDeniedNewEntriesBanner;
